import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';

import { getSkinProtectionList } from '@/lib/formItem';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection8SkinProtectionForm',
  props: {
  protectiveEquipmentOfSkin: {
    type: String,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
  isValid: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isValid", "update:protectiveEquipmentOfSkin"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:protectiveEquipmentOfSkin', data: string): void;
}), expose: any, slots: any, attrs: any }) {





const form = ref<InstanceType<typeof VForm> | null>(null);

const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updateProtectiveEquipmentOfSkin = (e: string) => {
  emits('update:protectiveEquipmentOfSkin', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,emits, form, updateIsValid, updateProtectiveEquipmentOfSkin, getSkinProtectionList, VForm, sharedMessages }
}

})